<!-- Category -->
@if (data && (!data.isChild || (data.isChild && data.subCategory))) {
  <div
    class="flex items-center"
    [attr.auto-qa]="autoTestAttribute"
    [style.margin-left]="!data.isChild ? '16px' : data.indentLevel * 32 + 'px'"
  >
    <!-- Toggle row open/closed -->
    <button
      class="flex items-center justify-center"
      (click)="componentParent.toggleService.toggleCategory(data.id, params.node)"
    >
      <div class="flex h-[24px] w-[24px] items-center justify-center">
        @if (data.isOpen) {
          <span class="ag-icon ag-icon-tree-open" style="font-weight: bold !important"></span>
        }
        @if (!data.isOpen) {
          <span class="ag-icon ag-icon-tree-closed" style="font-weight: bold !important"></span>
        }
      </div>
    </button>

    <div>
      <!-- Category name -->
      <div class="flex items-center text-xs">
        @if (componentParent.checkService.isCategoryUnforecasted(data.primarySettingsId) | async) {
          <aux-icon name="AlertTriangle" class="-ml-0.5 text-aux-red-dark" />
        }
        <span class="category-name overflow-hidden text-ellipsis">{{ data.categoryName }}</span>
      </div>
      <!-- Category checkbox -->
      <div class="apply-container">
        <aux-checkbox
          class="text-xs"
          [id]="'cat' + data.id"
          [checked]="data.primarySettingsOverride"
          [disabled]="
            disableCategory ||
            componentParent.isClosedMonthsProcessing ||
            componentParent.isForecastFinalized
          "
          [auxTooltip]="
            componentParent.checkService.pageLockedTooltipText(
              componentParent.isForecastFinalized || componentParent.isClosedMonthsProcessing
            )
          "
          [indeterminate]="
            data.primarySettingsOverride &&
            componentParent.checkService.isCategoryIndeterminate(data.id)
          "
          (customChange)="
            componentParent.toggleCategoryApplyAll(
              $event,
              data.primarySettingsId,
              data.primarySettingsOverride,
              data.id
            )
          "
        >
          Apply to activities
          @if (data.primarySettingsOverride && data.activityCheckedCount) {
            <span class="text-xxs">({{ data.activityCheckedCount }} Override)</span>
          }
        </aux-checkbox>
      </div>
    </div>
  </div>
}

<!-- Activity -->
@if (data && data.isChild && !data.subCategory) {
  <div class="items-left flex flex-col" [style.margin-left]="data.indentLevel * 16 + 40 + 'px'">
    <!-- Activity name -->
    <div class="flex items-center">
      @if (componentParent.checkService.isActivityUnforecasted(data.id) | async) {
        <aux-icon name="AlertTriangle" class="-ml-0.5 text-aux-red-dark" />
      }
      <div class="activity-name line-clamp-3 text-ellipsis text-xs">
        {{ data.categoryName }}
      </div>
    </div>
    <!-- Activity checkbox -->
    @if (data.parentCategory?.primarySettingsOverride) {
      <div class="apply-container text-xs">
        <aux-checkbox
          class="text-xs"
          [id]="'cat' + data.id"
          [checked]="data.primarySettingsOverride"
          [disabled]="
            disableCategory ||
            componentParent.isClosedMonthsProcessing ||
            !componentParent.userHasModifyPermissions ||
            componentParent.isForecastFinalized
          "
          [auxTooltip]="
            componentParent.checkService.pageLockedTooltipText(
              componentParent.isForecastFinalized || componentParent.isClosedMonthsProcessing
            )
          "
          (customChange)="
            componentParent.toggleActivityApplyAll(
              $event,
              data.fullActivity!,
              data.fullParentCategory!
            )
          "
        >
          Override
        </aux-checkbox>
      </div>
    }
  </div>
}
